/*
 * VULCAN
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/deploymentMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Deployment. */
var Deployment = /** @class */ (function () {
    /**
     * Create a Deployment.
     * @param {SecurityContext} client Reference to the service client.
     */
    function Deployment(client) {
        this.client = client;
    }
    Deployment.prototype.createOrUpdateApplications = function (applicationName, request, options, callback) {
        return this.client.sendOperationRequest({
            applicationName: applicationName,
            request: request,
            options: options
        }, createOrUpdateApplicationsOperationSpec, callback);
    };
    Deployment.prototype.getOrphanedPermissions = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getOrphanedPermissionsOperationSpec, callback);
    };
    return Deployment;
}());
export { Deployment };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var createOrUpdateApplicationsOperationSpec = {
    httpMethod: "PUT",
    path: "api/v10/deployment/tenants/applications/{applicationName}",
    urlParameters: [
        Parameters.applicationName0
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdateApplicationsRequest), { required: true })
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "TenantApplicationResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getOrphanedPermissionsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/deployment/tenants/permissions/orphaned",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "TenantOrphanedPermissionsResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=deployment.js.map